<template>
    <div class="info-warpper">
        <div class="bg-white margin-bottom-sm">
            <h3 class="info-title">个人资料</h3>
            <div class="padding-left-xl">
                <div class="info-item">
                    <span>姓名：</span>
                    <el-input v-model="name" readonly class="flex-sub"></el-input>
                </div>
                <div class="info-item">
                    <span>手机号(账号)：</span>
                    <el-input v-model="phone" readonly class="flex-sub"></el-input>
                </div>
            </div>
        </div>
        <div class="bg-white">
            <h3 class="info-title">修改密码</h3>
            <div class="padding-left-xl info-form">
                <el-form :model="setForm" :rules="rules" ref="setForm" label-width="110px" label-position="left">
                    <el-form-item label="旧密码：" prop="oldPass">
                        <el-input v-model="setForm.oldPass" placeholder="请输入旧密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：" prop="newPass">
                        <el-input v-model="setForm.newPass" placeholder="请输入新密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="newRPass">
                        <el-input v-model="setForm.newRPass" placeholder="请再次输入新密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item class="flex align-center justify-around" label-width="0">
                        <el-button class="padding-lr-xl" type="primary" @click="submitForm('setForm')">确认修改</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {adminAccountShow, changePass} from "@/api/login";

export default {
    name: "info",
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.setForm.checkPass !== '') {
                    this.$refs.setForm.validateField('checkPass');
                }
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.setForm.newPass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            name: '',
            phone: '',
            setForm: {
                oldPass: '',
                newPass: '',
                newRPass: '',
            },
            rules: {
                oldPass: [{required: true, message: '请输入旧密码', trigger: 'blur'},
                    {min: 6, max: 32, message: '密码长度为 6 到 32 个字符', trigger: 'blur'}],
                newPass: [{required: true, validator: validatePass, trigger: 'blur'},
                    {
                        pattern: '^(?=.*\\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$',
                        message: '密码需要包含数字及字母且8-20个字符',
                        trigger: 'change'
                    }],
                newRPass: [{required: true, validator: validatePass2, trigger: 'blur'},
                    {min: 6, max: 32, message: '密码长度为 6 到 32 个字符', trigger: 'blur'}],
            }
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "系统管理 / 个人中心", false);
        this.adminAccountShow()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {},
    methods: {
        //  修改密码提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await changePass(
                this.setForm.oldPass,
                this.setForm.newPass,
                this.setForm.newRPass,
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
        },
        //  h获取用户基本信息
        async adminAccountShow() {
            let _data = await adminAccountShow(this.user.id)
            this.name = _data.data.name
            this.phone = _data.data.username
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.info-warpper {
    .info-title {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        padding-left: 15px;
        margin-bottom: 30px;
        position: relative;

        &:before {
            position: absolute;
            left: 0;
            top: 50%;
            content: '';
            transform: translate(0, -50%);
            width: 4px;
            height: 20px;
            border-radius: 2px;
            background: #d00000;
        }
    }

    .info-item {
        display: flex;
        align-items: center;
        height: 40px;
        width: 400px;
        margin-bottom: 20px;

        span {
            display: block;
            width: 110px;
        }
    }

    .info-form {
        width: 450px;
    }
}

</style>